import React from 'react';
import { useTranslation } from 'react-i18next';

import { FaBell, FaLeaf, FaMoneyCheckAlt, FaChartBar } from 'react-icons/fa';
import '../styles/dashboard.css';



const Dashboard = () => {

         const { t, i18n } = useTranslation();
    

         const features = [
            {
              title: t("dashboard.reminder"),
              description: t("dashboard.reminderDescription"),
              icon: <FaBell size={40} />,
              link: '/reminders',
              color: '#aed581'
            },
            {
              title: t("dashboard.botany"),
              description: t("dashboard.botanyDescription"),
              icon: <FaLeaf size={40} />,
              link: '/plants',
              color: '#81c784'
            },
            {
              title: t("dashboard.payment"),
              description: t("dashboard.paymentDescription"),
              icon: <FaMoneyCheckAlt size={40} />,
              link: '/plans',
              color: '#4db6ac'
            },
            // {
            //   title: t("dashboard.report"),
            //   description: t("dashboard.reportDescription"),
            //   icon: <FaChartBar size={40} />,
            //   link: '/reports',
            //   color: '#64b5f6'
            // }
          ];

  return (
    <div className="container py-5">
      <div className="row g-4">
        {features.map((item, index) => (
          <div key={index} className="col-6 col-md-4 col-12">
            <a href={item.link} className="feature-card text-decoration-none text-dark">
              <div className="card shadow h-100 text-center p-3" 
                    style={{ backgroundColor: item.color, borderRadius: '20px' }}>
                <div className="mb-2">{item.icon}</div>
                <h5 className="fw-bold">{item.title}</h5>
                <p className="small">{item.description}</p>
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Dashboard;
